import { createContext } from 'react'

const xBarContext = createContext()

export default xBarContext
